module.exports = __webpack_public_path__ + "static/media/sombra-lombada-interna.a5d3a5c7.svg";